import React from "react";
import {
    ArAgingBucket,
    AR_AGING_BUCKET_LABELS,
    AR_AGING_BUCKET_ORDER,
} from "@common/types/reports/ar-aging";
import { noop } from "@common/helpers/function";
import {
    FilterMultiselect,
    FilterMultiselectOption,
    FilterMultiselectValue,
} from "@components/pageHeader/filters/FilterMultiselect/FilterMultiselect";
import { BaseFilterProps } from "../../lib";
import styles from "./AgingPeriodFilter.module.scss";

const options: FilterMultiselectOption[] = AR_AGING_BUCKET_ORDER.map(
    (bucket) => ({
        value: bucket,
        label: AR_AGING_BUCKET_LABELS[bucket],
        searchableLabel: AR_AGING_BUCKET_LABELS[bucket],
    }),
);

function isArAgingBucketValue(
    value: FilterMultiselectValue,
): value is ArAgingBucket {
    return (
        typeof value === "string" &&
        AR_AGING_BUCKET_ORDER.some((bucket) => bucket === value)
    );
}

/**
 * A/R Aging Detail: aging-period filter, replacing the old standalone
 * "Bucket" dropdown button. Rendered inside the standard filters overlay
 * (FiltersOverlay), like every other multi-select filter tab, instead of a
 * bespoke `additionalButtons` control.
 */
export const AgingPeriodFilter: React.FC<BaseFilterProps> = ({
    filters,
    onChange,
}) => {
    const selectedBuckets = filters.agingBuckets ?? [];

    return (
        <div className={styles.filter}>
            <FilterMultiselect
                maxListHeight={340}
                inDropdown={false}
                searchable={false}
                options={options}
                value={selectedBuckets}
                onChange={(values) => {
                    const agingBuckets = values.filter(isArAgingBucketValue);
                    onChange({
                        agingBuckets:
                            agingBuckets.length > 0 ? agingBuckets : undefined,
                    });
                }}
                name="agingBuckets"
                onBlur={noop}
            />
        </div>
    );
};
